module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_03-2091b8492dedb9b0d5a3beda73aaa457.png";